module.exports = __webpack_public_path__ + "img/17316304.e0e1ae52.png";